export const ProfileHeader = ({ userData, loading }) => {
  // fallback: first letter of name (uppercase)
  const getInitial = (name) => name?.charAt(0)?.toUpperCase() || "?";

  return (
    <div className="rounded-2xl shadow bg-white px-6">
      <div className="h-56 md:h-44 flex flex-col md:flex-row items-center gap-6">
        <div className="w-32 h-32 rounded-full overflow-hidden shadow flex items-center justify-center bg-redbg text-white text-4xl font-bold">
          {loading ? (
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
          ) : userData.avatar ? (
            <img
              src={userData.avatar}
              alt={userData.name}
              className="w-full h-full object-cover"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
          ) : (
            getInitial(userData.name)
          )}
        </div>

        <div className="flex-1 text-center md:text-left space-y-2">
          {loading ? (
            <>
              <div className="h-8 bg-gray-200 rounded w-48 animate-pulse"></div>
              <div className="h-6 bg-gray-200 rounded w-64 animate-pulse"></div>
            </>
          ) : (
            <>
              <h2 className="text-3xl font-bold">{userData.name}</h2>
              <p className="text-gray-500 text-lg">{userData.email}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};